import Component from './BadgeIcon.component';

export default Component;
